<app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
<div class="modal-header impact-outcome-header">
  <div class="modal-title f-20">Bulk Update</div>
  <div class="modal-btn-right">
    <div class="btn-group mr-4">
      <button class="btn btn-blue text-white btn-sm mr-2" (click)="updateImpactAssessment()">Save</button>
    </div>
    <button class="fa fa-times" [mat-dialog-close]="" style="float: right;cursor: pointer;background: none;border:none"
      aria-hidden="true"></button>
  </div>
</div>
<div class="modal-body" style="height: 750px;overflow: auto;">





  <!-- <div class="modal-body"> -->
  <div class="pl-2 ia-details-div">
    <mat-accordion id="AdditionalDetails">
      <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2 mt-2">
        <mat-expansion-panel-header class="ia-mat-panel">
          <mat-panel-title>
            <span class="text-header inc-f">
              Additional Details
            </span><span *ngIf="templateNo==3" class="text-danger ml-3 float-right">( * fields are mandatory )</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="row ml-2 mt-1">
          <div class="col-lg-2">
            <label class="control-label fw">Division <span class="stars">*</span></label>
            <ng-select *ngIf="searchedJuris.length > 0" [items]="searchedJuris" bindLabel="name" appendTo="body"
              (change)="onSelectJuris($event)" [(ngModel)]="selectedJuris">
            </ng-select>
          </div>
          <div class="col-lg-2" *ngIf="templateNo!=3">
            <label class="control-label fw">Legal Entity</label>
            <input type="text" class="form-control form-control-sm" [(ngModel)]="impactAssessment.legalEntity" />
          </div>
          <div class="col-lg-4" *ngIf="templateNo==3">
            <label class="control-label fw">Legal Entity <span class="stars">*</span></label>
            <mat-chip-grid #legalEntityList>
              <mat-chip-row *ngFor="let entity of selectedEntity|stringToArrayParent" [selectable]="selectable"
                [removable]="removable" (removed)="removeLegalEntity(entity)">
                {{entity}}
                <mat-icon matChipRemove *ngIf="removable && isADetailPermission" class="clear-icons">X
                </mat-icon>
              </mat-chip-row>
              <input class="form-control form-control-sm mat-autodd-input border-bottom"
                #trigautoLegalEntity="matAutocompleteTrigger" [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                #LegalEntityInput [formControl]="searchLegalEntityCntrl" [matAutocomplete]="legalEntityAutocomplete"
                [matChipInputFor]="legalEntityList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="addOnBlur" autocomplete="off" (matChipInputTokenEnd)="addLegalEntity($event)">
            </mat-chip-grid>
            <mat-autocomplete #legalEntityAutocomplete="matAutocomplete"
              (optionSelected)="selectedLegalEntityEvent($event)">
              <mat-option *ngFor="let item of legalEntityDD" [value]="item.title">
                {{item.title}}
              </mat-option>
            </mat-autocomplete>
          </div>
          <div class="col-lg-2">
            <label class="control-label fw">Topic</label>
            <mat-chip-grid #topicList>
              <mat-chip-row *ngFor="let item of topicDD" [selectable]="selectable" [removable]="removable"
                (removed)="removeTopic(item)">
                {{item}}
                <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
              </mat-chip-row>
              <input class="form-control form-control-sm mat-autodd-input border-bottom"
                (keydown)="getFilteredData('Topic', $event)" #topicInput [formControl]="searchTopicCntrl"
                [matAutocomplete]="topicAutoComplete" [matChipInputFor]="topicList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                autocomplete="off" (matChipInputTokenEnd)="addTopic($event)">
            </mat-chip-grid>
            <mat-autocomplete #topicAutoComplete="matAutocomplete" (optionSelected)="selectedTopicEvent($event)">
              <mat-option *ngFor="let item of searchedTopics" [value]="item.value">
                {{item.name}}
              </mat-option>
            </mat-autocomplete>
          </div>
          <div class="col-lg-2">
            <label class="control-label fw">Rule Type</label>
            <select class="form-control form-control-sm" [(ngModel)]="impactAssessment.ruleType">
              <option *ngFor="let option of ruleType" value="{{option}}">{{option}}</option>
            </select>
          </div>
          <div class="col-lg-2">
            <label class="control-label fw">Effective Date</label>
            <div class="input-group input-group-sm">
              <input matInput [matDatepicker]="picker" (click)="picker.open()"
                class="form-control form-control-sm border-bottom" name="applicationDate"
                [(ngModel)]="impactAssessment.applicationDate">
              <div class="input-group-append">
                <span class="input-group-text fa fa-calendar" (click)="picker.open()"></span>
              </div>
            </div>
            <mat-datepicker #picker></mat-datepicker>
          </div>

          <div class="col-lg-6 mt-1" *ngIf="templateNo == (0 || 3)">
            <label class="control-label fw">Line of Business <span class="stars">*</span></label>
            <mat-chip-grid #lineOfBusinessList>
              <mat-chip-row *ngFor="let entity of impactAssessment.lineOfBusiness|stringToArrayParent"
                [selectable]="selectable" [removable]="removable" (removed)="removeLineOfBusiness(entity)">
                {{entity}}
                <mat-icon matChipRemove *ngIf="removable && isADetailPermission" class="clear-icons">X
                </mat-icon>
              </mat-chip-row>
              <input class="form-control form-control-sm mat-autodd-input border-bottom"
                #trigautoLineOfBusiness="matAutocompleteTrigger"
                [attr.disabled]="!isADetailPermission ? 'disabled' : null" #LineOfBusinessInput
                [formControl]="searchLineOfBusinessCntrl" [matAutocomplete]="lineOfBusinessAutocomplete"
                [matChipInputFor]="lineOfBusinessList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
                (matChipInputTokenEnd)="addLineOfBusiness($event)">
            </mat-chip-grid>
            <mat-autocomplete #lineOfBusinessAutocomplete="matAutocomplete"
              (optionSelected)="selectedLineOfBusinessEvent($event)">
              <mat-option *ngFor="let item of lineOfBusiness" [value]="item">
                {{item}}
              </mat-option>
            </mat-autocomplete>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <app-progress-bar [isLoading]="isLoadingDD"></app-progress-bar>


    <!-- Template 1 -->
    <div *ngIf="templateNo==0|| templateNo==1">
      <mat-accordion id="AssessmentDetails">
        <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2 mt-2">
          <mat-expansion-panel-header class="ia-mat-panel">
            <mat-panel-title>
              <span class="text-header inc-f">
                Assessment Details
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row ml-2 my-4">
            <div class="col-lg-4">
              <label class="control-label fw">Assessment Team</label>
              <input type="text" class="form-control form-control-sm"
                [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                [(ngModel)]="impactAssessment.assessmentTeam">
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Assessor</label>
              <mat-chip-grid #assessorList>
                <mat-chip-row *ngFor="let assessor of assessorDD" [selectable]="selectable" [removable]="removable"
                  (removed)="removeAssessor(assessor)">
                  {{assessor}}
                  <mat-icon matChipRemove *ngIf="removable && isADetailPermission">x</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm mat-autodd-input border-bottom"
                  (keydown)="getFilteredData('Assessor', $event)"
                  [attr.disabled]="!isADetailPermission ? 'disabled' : null" #assessorInput
                  [formControl]="searchAssessorCntrl" [matAutocomplete]="assessorAutocomplete"
                  [matChipInputFor]="assessorList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur" autocomplete="off" (matChipInputTokenEnd)="addAssessor($event)">
              </mat-chip-grid>
              <mat-autocomplete #assessorAutocomplete="matAutocomplete"
                (optionSelected)="selectedAssessorEvent($event)">
                <mat-option *ngFor="let assessor of searchedAssessor" [value]="assessor.value">
                  {{assessor.name}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Assessor Delegate</label>
              <mat-chip-grid #assessorDelList>
                <mat-chip-row *ngFor="let assessor of assessorDelDD" [selectable]="selectable" [removable]="removable"
                  (removed)="removeAssessorDelegate(assessor)">
                  {{assessor}}
                  <mat-icon matChipRemove *ngIf="removable && isADetailPermission">x</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm mat-autodd-input border-bottom"
                  (keydown)="getFilteredData('AssessorDelegate', $event)"
                  [attr.disabled]="!isADetailPermission ? 'disabled' : null" #assessorDelInput
                  [formControl]="searchAssessorDelCntrl" [matAutocomplete]="assessorDelAutocomplete"
                  [matChipInputFor]="assessorDelList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
                  (matChipInputTokenEnd)="addAssessorDelegate($event)">
              </mat-chip-grid>
              <mat-autocomplete #assessorDelAutocomplete="matAutocomplete"
                (optionSelected)="selectedAssessorDelegateEvent($event)">
                <mat-option *ngFor="let assessor of searchedAssessorDel" [value]="assessor.value">
                  {{assessor.name}}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text mb-3">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isIADetails1"
                    (click)="isIADetails1 = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIADetails1"
                    (click)="isIADetails1 = false"></span>
                  <span class="control-label fw">
                    Publication Proposal - Please provide a summary of what the publication is proposing
                  </span>
                </div>
                <app-ck-editor [(childVariable)]="impactAssessment.assessmentDetails1" id="assessmentDetails1"
                  class="f-16" *ngIf="isADetailPermission && isIADetails1"></app-ck-editor>
                <!-- <ckeditor [editor]="Editor" id="assessmentDetails1" class="f-16" *ngIf="isADetailPermission && isIADetails1"
                  [(ngModel)]="impactAssessment.assessmentDetails1">
                </ckeditor> -->
              </div>
            </div>
          </div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text mb-3">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isIADetails2"
                    (click)="isIADetails2 = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIADetails2"
                    (click)="isIADetails2 = false"></span>
                  <span class="control-label fw">
                    Impact - Please provide a summary of publication's impact on
                    business/operational/processes/policies
                  </span>
                </div>
                <app-ck-editor [(childVariable)]="impactAssessment.assessmentDetails2" id="assessmentDetails2"
                  class="f-16" *ngIf="isADetailPermission && isIADetails2"></app-ck-editor>
                <!-- <ckeditor [editor]="Editor" id="assessmentDetails2" class="f-16" *ngIf="isADetailPermission && isIADetails2"
                  [(ngModel)]="impactAssessment.assessmentDetails2">
                </ckeditor> -->
              </div>
            </div>
          </div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-3">
              <label class="control-label fw">Capital/RWA Impact</label>
              <select class="form-control form-control-sm" [(ngModel)]="impactAssessment.capitalRWAImpact">
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">
                Impact Rating Lite
                <span class="label label-default bg-default p5-20"
                  *ngIf="!impactAssessment.impactRatingLite">None</span>
                <span class="label label-default bg-red p5-20"
                  *ngIf="impactAssessment.impactRatingLite === 'Very High'">Very
                  High</span>
                <span class="label ml-2 label-default bg-orange p5-20"
                  *ngIf="impactAssessment.impactRatingLite === 'High'">High</span>
                <span class="label ml-2 label-default bg-yellow p5-20"
                  *ngIf="impactAssessment.impactRatingLite === 'Medium'">Medium</span>
                <span class="label ml-2 label-default bg-green p5-20"
                  *ngIf="impactAssessment.impactRatingLite === 'Low'">Low</span>
              </label>
              <select class="form-control form-control-sm" [(ngModel)]="impactAssessment.impactRatingLite">
                <option value="Low">Low</option>
                <option value="Medium">Medium</option>
                <option value="High">High</option>
                <option value="Very High">Very High</option>
              </select>
            </div>
          </div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text mb-3">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isIADetails3"
                    (click)="isIADetails3 = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIADetails3"
                    (click)="isIADetails3 = false"></span>
                  <span class="control-label fw">
                    Actions Required - Please provide a summary of the actions needed to comply with publication
                    proposal
                  </span>
                </div>
                <app-ck-editor [(childVariable)]="impactAssessment.actionRequired" id="actionRequired" class="f-16"
                  *ngIf="isADetailPermission && isIADetails3"></app-ck-editor>
                <!-- <ckeditor [editor]="Editor" id="actionRequired" class="f-16" *ngIf="isADetailPermission && isIADetails3"
                  [(ngModel)]="impactAssessment.actionRequired">
                </ckeditor> -->
              </div>
            </div>
          </div>
          <div class="row ml-2 my-4">
            <div class="col-lg-6">
              <label class="control-label fw">Implementation Type</label>
              <select class="form-control form-control-sm" [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                [(ngModel)]="impactAssessment.implementationType">
                <option *ngFor="let option of implementationType" value="{{option}}">{{option}}</option>
              </select>
            </div>
            <div class="col-lg-6">
              <label class="control-label fw">Project Reference</label>
              <input type="text" class="form-control form-control-sm" [(ngModel)]="impactAssessment.projectReference" />
            </div>
          </div>
          <div class="row ml-2 my-4">
            <div class="col-lg-4">
              <label class="control-label fw">Next Action Date</label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="assessmentDueDate"
                  [attr.disabled]="!isADetailPermission ? 'disabled' : null" (click)="assessmentDueDate.open()"
                  class="form-control form-control-sm border-bottom" [(ngModel)]="impactAssessment.assessmentDueDate"
                  name="AssessmentDueDate" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" *ngIf="isADetailPermission"
                    (click)="assessmentDueDate.open()"></span>
                  <span class="input-group-text fa fa-calendar" *ngIf="!isADetailPermission"></span>
                </div>
              </div>
              <mat-datepicker #assessmentDueDate></mat-datepicker>
            </div>
            <div class="col-lg-8">
              <label class="control-label fw">Next Action Step</label>
              <input type="text" class="form-control form-control-sm" [(ngModel)]="impactAssessment.nextActionStep" />
            </div>
          </div>
          <div class="row ml-2 my-4">
            <div class="col-lg-4">
              <label class="control-label fw">Assessment Status</label>
              <select class="form-control form-control-sm" [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                [(ngModel)]="impactAssessment.assessmentStatus">
                <option *ngFor="let option of assessmentStatus" value="{{option}}">{{option}}</option>
              </select>
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Assessment Last Edited</label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="assessmentLastEdited" disabled (click)="assessmentLastEdited.open()"
                  class="form-control form-control-sm border-bottom" [(ngModel)]="impactAssessment.assessmentLastEdited"
                  name="AssessmentLastEdited" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" disabled (click)="assessmentLastEdited.open()"></span>
                </div>
              </div>
              <mat-datepicker #assessmentLastEdited></mat-datepicker>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <mat-accordion id="ReviewDetails">
        <mat-expansion-panel class="ia-expansion-panel pl-2 mt-2">
          <mat-expansion-panel-header class="ia-mat-panel">
            <mat-panel-title>
              <span class="text-header inc-f">
                Review Details
              </span>
              <span class="cursor-pointer ml-3" style="font-size:14px">
                <i class="fa fa-square-o icon-font vertical-align-top" (click)="checkReviewDetailRequired('Checked')"
                  *ngIf="!isRDNotRequired" aria-hidden="true"></i>
                <i class="fa fa-check-square icon-font vertical-align-top"
                  (click)="checkReviewDetailRequired('UnChecked')" *ngIf="isRDNotRequired" aria-hidden="true"></i>
                Not Required
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row ml-2 mt-1">
            <div class="col-lg-4">
              <label class="control-label fw">Reviewer Team</label>
              <input type="text" [attr.disabled]="!isRDetailPermission ? 'disabled' : null"
                class="form-control form-control-sm" [(ngModel)]="impactAssessment.reviewTeam" />
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Reviewer</label>
              <mat-chip-grid #reviewerList>
                <mat-chip-row *ngFor="let reviewer of reviewerDD" [selectable]="selectable" [removable]="removable"
                  (removed)="removeReviewer(reviewer)">
                  {{reviewer}}
                  <mat-icon matChipRemove *ngIf="removable && isRDetailPermission">x</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm mat-autodd-input border-bottom"
                  (keydown)="getFilteredData('Reviewer', $event)"
                  [attr.disabled]="!isRDetailPermission ? 'disabled' : null" #reviewerInput
                  [formControl]="searchReviewerCntrl" [matAutocomplete]="reviewerAutocomplete"
                  [matChipInputFor]="reviewerList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur" autocomplete="off" (matChipInputTokenEnd)="addReviewer($event)">
              </mat-chip-grid>
              <mat-autocomplete #reviewerAutocomplete="matAutocomplete"
                (optionSelected)="selectedReviewerEvent($event)">
                <mat-option *ngFor="let reviewer of searchedReviewer" [value]="reviewer.value">
                  {{reviewer.name}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Reviewer Delegate</label>
              <mat-chip-grid #reviewerDelList>
                <mat-chip-row *ngFor="let reviewer of reviewerDelDD" [selectable]="selectable" [removable]="removable"
                  (removed)="removeReviewerDelegate(reviewer)">
                  {{reviewer}}
                  <mat-icon matChipRemove *ngIf="removable && isRDetailPermission">x</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm mat-autodd-input border-bottom"
                  (keydown)="getFilteredData('ReviewerDelegate', $event)"
                  [attr.disabled]="!isRDetailPermission ? 'disabled' : null" #reviewerDelInput
                  [formControl]="searchReviewerDelCntrl" [matAutocomplete]="reviewerDelAutocomplete"
                  [matChipInputFor]="reviewerDelList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
                  (matChipInputTokenEnd)="addReviewerDelegate($event)">
              </mat-chip-grid>
              <mat-autocomplete #reviewerDelAutocomplete="matAutocomplete"
                (optionSelected)="selectedReviewerDelegateEvent($event)">
                <mat-option *ngFor="let reviewer of searchedReviewerDel" [value]="reviewer.value">
                  {{reviewer.name}}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-4">
              <label class="control-label fw">Reviewer Due Date</label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="reviewDueDate"
                  [attr.disabled]="!isRDetailPermission ? 'disabled' : null" (click)="reviewDueDate.open()"
                  class="form-control form-control-sm border-bottom" [(ngModel)]="impactAssessment.reviewDueDate"
                  name="ReviewDueDate" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" *ngIf="isRDetailPermission"
                    (click)="reviewDueDate.open()"></span>
                  <span class="input-group-text fa fa-calendar" *ngIf="!isRDetailPermission"></span>
                </div>
              </div>
              <mat-datepicker #reviewDueDate></mat-datepicker>
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Reviewer Last Edited</label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="reviewLastEdited" disabled (click)="reviewLastEdited.open()"
                  class="form-control form-control-sm border-bottom" [(ngModel)]="impactAssessment.reviewLastEdited"
                  name="ReviewLastEdited" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" disabled (click)="reviewLastEdited.open()"></span>
                </div>
              </div>
              <mat-datepicker #reviewLastEdited></mat-datepicker>
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Review Status</label>
              <select class="form-control form-control-sm" [attr.disabled]="!isRDetailPermission ? 'disabled' : null"
                [(ngModel)]="impactAssessment.reviewStatus">
                <option *ngFor="let option of reviewStatus" value="{{option}}">{{option}}</option>
              </select>
            </div>
          </div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text mb-3">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="isRDetailPermission && !isRDetails"
                    (click)="isRDetails = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="isRDetailPermission && isRDetails"
                    (click)="isRDetails = false"></span>
                  <span class="control-label fw">
                    Review Details
                  </span>
                </div>
                <app-ck-editor [(childVariable)]="impactAssessment.reviewDetails" id="reviewDetails" class="f-16"
                  *ngIf="isRDetails"></app-ck-editor>
                <!-- <ckeditor [editor]="Editor" id="reviewDetails" class="f-16" *ngIf="isRDetails"
                  [(ngModel)]="impactAssessment.reviewDetails">
                </ckeditor> -->
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <mat-accordion id="ImplementationDetails">
        <mat-expansion-panel class="ia-expansion-panel pl-2 mt-2">
          <mat-expansion-panel-header class="ia-mat-panel">
            <mat-panel-title>
              <span class="text-header inc-f">
                Implementation Details
              </span>
              <span class="cursor-pointer ml-3" style="font-size:14px">
                <i class="fa fa-square-o icon-font vertical-align-top"
                  (click)="checkImplementationDetailRequired('Checked')" *ngIf="!isIDNotRequired"
                  aria-hidden="true"></i>
                <i class="fa fa-check-square icon-font vertical-align-top"
                  (click)="checkImplementationDetailRequired('UnChecked')" *ngIf="isIDNotRequired"
                  aria-hidden="true"></i>
                Not Required
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row ml-2 mt-1">
            <div class="col-lg-4">
              <label class="control-label fw">Implementation Team</label>
              <input type="text" [attr.disabled]="!isIDetailPermission ? 'disabled' : null"
                class="form-control form-control-sm" [(ngModel)]="impactAssessment.implementationTeam" />
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Implementation Owner</label>
              <mat-chip-grid #imptList>
                <mat-chip-row *ngFor="let implmt of imptOwnerDD" [selectable]="selectable" [removable]="removable"
                  (removed)="removeImplementationOwner(implmt)">
                  {{implmt}}
                  <mat-icon matChipRemove *ngIf="removable && isIDetailPermission">x</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm mat-autodd-input border-bottom"
                  (keydown)="getFilteredData('Owner', $event)"
                  [attr.disabled]="!isIDetailPermission ? 'disabled' : null" #imptOwnerInput
                  [formControl]="searchImptOwnerCntrl" [matAutocomplete]="imptOwnerAutocomplete"
                  [matChipInputFor]="imptList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
                  (matChipInputTokenEnd)="addImplementationOwner($event)">
              </mat-chip-grid>
              <mat-autocomplete #imptOwnerAutocomplete="matAutocomplete"
                (optionSelected)="selectedImplementationOwnerEvent($event)">
                <mat-option *ngFor="let implmt of searchedImptOwner" [value]="implmt.value">
                  {{implmt.name}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Owner Delegate</label>
              <mat-chip-grid #ownerDelList>
                <mat-chip-row *ngFor="let owner of ownerDelDD" [selectable]="selectable" [removable]="removable"
                  (removed)="removeOwnerDel(owner)">
                  {{owner}}
                  <mat-icon matChipRemove *ngIf="removable && isIDetailPermission">x</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm mat-autodd-input border-bottom"
                  (keydown)="getFilteredData('OwnerDelegate', $event)"
                  [attr.disabled]="!isIDetailPermission ? 'disabled' : null" #ownerDelInput
                  [formControl]="searchOwnerDelCntrl" [matAutocomplete]="ownerDelAutocomplete"
                  [matChipInputFor]="ownerDelList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur" autocomplete="off" (matChipInputTokenEnd)="addOwnerDel($event)">
              </mat-chip-grid>
              <mat-autocomplete #ownerDelAutocomplete="matAutocomplete"
                (optionSelected)="selectedOwnerDelEvent($event)">
                <mat-option *ngFor="let owner of searchedOwnerDel" [value]="owner.value">
                  {{owner.name}}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-4">
              <label class="control-label fw">Implementation Due Date</label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="implementationDueDate"
                  [attr.disabled]="!isIDetailPermission ? 'disabled' : null" (click)="implementationDueDate.open()"
                  class="form-control form-control-sm border-bottom"
                  [(ngModel)]="impactAssessment.implementationDueDate" name="ImplementationDueDate" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" *ngIf="isIDetailPermission"
                    (click)="implementationDueDate.open()"></span>
                  <span class="input-group-text fa fa-calendar" *ngIf="!isIDetailPermission"></span>
                </div>
              </div>
              <mat-datepicker #implementationDueDate></mat-datepicker>
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Implementation Last Edited</label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="implementationLastEdited" disabled
                  (click)="implementationLastEdited.open()" class="form-control form-control-sm border-bottom"
                  [(ngModel)]="impactAssessment.implementationLastEdited" name="ImplementationLastEdited" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" disabled
                    (click)="implementationLastEdited.open()"></span>
                </div>
              </div>
              <mat-datepicker #implementationLastEdited></mat-datepicker>
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Implementation Status</label>
              <select class="form-control form-control-sm" [attr.disabled]="!isIDetailPermission ? 'disabled' : null"
                [(ngModel)]="impactAssessment.implementationStatus">
                <option *ngFor="let option of implementationStatus" value="{{option}}">{{option}}</option>
              </select>
            </div>
          </div>

          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text mb-3">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="isIDetailPermission && !isIDetails"
                    (click)="isIDetails = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIDetailPermission && isIDetails"
                    (click)="isIDetails = false"></span>
                  <span class="control-label fw">
                    Implementation Details
                  </span>
                </div>
                <div class="text-area-css overflow-auto disabled-div" *ngIf="!isIDetailPermission"
                  [innerHTML]="sanitizeHtml(impactAssessment.implementationDetails)"></div>
                <app-ck-editor [(childVariable)]="impactAssessment.implementationDetails" id="implementationDetails" class="f-16" *ngIf="isIDetails"></app-ck-editor>
                <!-- <ckeditor [editor]="Editor" id="implementationDetails" class="f-16" *ngIf="isIDetails"
                  [(ngModel)]="impactAssessment.implementationDetails">
                </ckeditor> -->
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <!-- Template 2 -->
    <div *ngIf="templateNo==2">
      <mat-accordion id="AssessmentLegal">
        <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2 mt-2">
          <mat-expansion-panel-header class="ia-mat-panel">
            <mat-panel-title>
              <span class="text-header inc-f">
                Assessment - Legal
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row ml-2 my-4">
            <div class="col-lg-4">
              <label class="control-label fw">Assessor</label>
              <mat-slide-toggle class="ml-2" [(ngModel)]="assessorToggle">Assign To Division</mat-slide-toggle>
              <mat-chip-grid #assessorList>
                <mat-chip-row *ngFor="let assessor of assessorDD" [selectable]="selectable" [removable]="removable"
                  (removed)="removeAssessor(assessor)">
                  {{assessor}}
                  <mat-icon matChipRemove *ngIf="removable && isADetailPermission">x</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm mat-autodd-input border-bottom"
                  #trigautoAssessor="matAutocompleteTrigger" (keydown)="getFilteredData('Assessor', $event)"
                  [attr.disabled]="!isADetailPermission ? 'disabled' : null" #assessorInput
                  [formControl]="searchAssessorCntrl" [matAutocomplete]="assessorAutocomplete"
                  [matChipInputFor]="assessorList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur" autocomplete="off" (matChipInputTokenEnd)="addAssessor($event)">
              </mat-chip-grid>
              <mat-autocomplete #assessorAutocomplete="matAutocomplete"
                (optionSelected)="selectedAssessorEvent($event)">
                <mat-option *ngFor="let assessor of (assessorToggle?searchedJurisdiction:searchedAssessor)"
                  [value]="assessorToggle?assessor.title:assessor.value">
                  {{assessorToggle?assessor.title:assessor.name}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Compliance Assessor</label>
              <mat-slide-toggle class="ml-2" [(ngModel)]="complianceToggle">Assign To Division</mat-slide-toggle>
              <mat-chip-grid #assessorDelList>
                <mat-chip-row *ngFor="let assessor of assessorDelDD" [selectable]="selectable" [removable]="removable"
                  (removed)="removeAssessorDelegate(assessor)">
                  {{assessor}}
                  <mat-icon matChipRemove *ngIf="removable && isADetailPermission">x</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm mat-autodd-input border-bottom"
                  #trigautoAssessorDelegate="matAutocompleteTrigger"
                  (keydown)="getFilteredData('AssessorDelegate', $event)"
                  [attr.disabled]="!isADetailPermission ? 'disabled' : null" #assessorDelInput
                  [formControl]="searchAssessorDelCntrl" [matAutocomplete]="assessorDelAutocomplete"
                  [matChipInputFor]="assessorDelList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
                  (matChipInputTokenEnd)="addAssessorDelegate($event)">
              </mat-chip-grid>
              <mat-autocomplete #assessorDelAutocomplete="matAutocomplete"
                (optionSelected)="selectedAssessorDelegateEvent($event)">
                <mat-option *ngFor="let assessor of (complianceToggle?searchedJurisdiction:searchedAssessorDel)"
                  [value]="assessorToggle?assessor.title:assessor.value">
                  {{complianceToggle?assessor.title:assessor.name}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Action By</label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="assessmentDueDate"
                  [attr.disabled]="!isADetailPermission ? 'disabled' : null" (click)="assessmentDueDate.open()"
                  class="form-control form-control-sm border-bottom" [(ngModel)]="impactAssessment.assessmentDueDate"
                  name="AssessmentDueDate" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" *ngIf="isADetailPermission"
                    (click)="assessmentDueDate.open()"></span>
                  <span class="input-group-text fa fa-calendar" *ngIf="!isADetailPermission"></span>
                </div>
              </div>
              <mat-datepicker #assessmentDueDate>
              </mat-datepicker>
            </div>
          </div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isIADetails1"
                    (click)="isIADetails1 = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIADetails1"
                    (click)="isIADetails1 = false"></span>
                  <span class="control-label fw">
                    Publication Proposal - Please provide a summary of what the publication is proposing
                  </span>
                </div>
                <div class="text-area-css overflow-auto"
                  *ngIf="iaDetailHistory && iaDetailHistory.assessmentDetails1.length > 0">
                  <div *ngFor="let detailItem of iaDetailHistory.assessmentDetails1">
                    <div class="pt-3" *ngIf="detailItem.itemTitle">
                      <div class="f-16" [innerHTML]="detailItem.itemTitle"></div>
                    </div>
                  </div>
                </div>
                <div class="text-area-css overflow-auto disabled-div"
                  *ngIf="!isADetailPermission && iaDetailHistory && iaDetailHistory.assessmentDetails1.length === 0"
                  [innerHTML]="sanitizeHtml(impactAssessment.assessmentDetails1)"></div>
                <app-ck-editor [(childVariable)]="impactAssessment.assessmentDetails1" id="assessmentDetails1" class="f-16" *ngIf="isADetailPermission && isIADetails1"></app-ck-editor>
                <!-- <ckeditor [editor]="Editor" id="assessmentDetails1" class="f-16"
                  *ngIf="isADetailPermission && isIADetails1" [(ngModel)]="impactAssessment.assessmentDetails1">
                </ckeditor> -->
              </div>
            </div>
          </div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isIADetails2"
                    (click)="isIADetails2 = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIADetails2"
                    (click)="isIADetails2 = false"></span>
                  <span class="control-label fw">
                    Impact - Please provide a summary of publication's impact on
                    business/operational/processes/policies
                  </span>
                </div>
                <div class="text-area-css overflow-auto"
                  *ngIf="iaDetailHistory && iaDetailHistory.assessmentDetails2.length > 0">
                  <div *ngFor="let detailItem of iaDetailHistory.assessmentDetails2">
                    <div class="pt-3" *ngIf="detailItem.itemTitle">
                      <div class="f-16" [innerHTML]="detailItem.itemTitle"></div>
                    </div>
                  </div>
                </div>
                <div class="text-area-css overflow-auto disabled-div"
                  *ngIf="!isADetailPermission && iaDetailHistory && iaDetailHistory.assessmentDetails2.length === 0"
                  [innerHTML]="sanitizeHtml(impactAssessment.assessmentDetails2)"></div>
                <app-ck-editor [(childVariable)]="impactAssessment.assessmentDetails2" id="assessmentDetails2" class="f-16" *ngIf="isADetailPermission && isIADetails2"></app-ck-editor>
                <!-- <ckeditor [editor]="Editor" id="assessmentDetails2" class="f-16"
                  *ngIf="isADetailPermission && isIADetails2" [(ngModel)]="impactAssessment.assessmentDetails2">
                </ckeditor> -->
              </div>
            </div>
          </div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isIADetails3"
                    (click)="isIADetails3 = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIADetails3"
                    (click)="isIADetails3 = false"></span>
                  <span class="control-label fw">
                    Actions Required - Please provide a summary of the actions needed to comply with publication
                    proposal
                  </span>
                </div>
                <div class="text-area-css overflow-auto"
                  *ngIf="iaDetailHistory && iaDetailHistory.actionRequired.length > 0">
                  <div *ngFor="let detailItem of iaDetailHistory.actionRequired">
                    <div class="pt-3" *ngIf="detailItem.itemTitle">
                      <div class="f-16" [innerHTML]="detailItem.itemTitle"></div>
                    </div>
                  </div>
                </div>
                <div class="text-area-css overflow-auto disabled-div"
                  *ngIf="!isADetailPermission && iaDetailHistory && iaDetailHistory.actionRequired.length === 0"
                  [innerHTML]="sanitizeHtml(impactAssessment.actionRequired)"></div>
                  <app-ck-editor [(childVariable)]="impactAssessment.actionRequired" id="actionRequired" class="f-16" *ngIf="isADetailPermission && isIADetails3"></app-ck-editor>
                <!-- <ckeditor [editor]="Editor" id="actionRequired" class="f-16" *ngIf="isADetailPermission && isIADetails3"
                  [(ngModel)]="impactAssessment.actionRequired">
                </ckeditor> -->
              </div>
            </div>
          </div>

        </mat-expansion-panel>
      </mat-accordion>
      <mat-accordion id="ImpactAnalysis">
        <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2 mt-2">
          <mat-expansion-panel-header class="ia-mat-panel">
            <mat-panel-title>
              <span class="text-header inc-f">
                Impact Analysis
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row ml-2 mt-1">
            <div class="col-lg-3">
              <label class="control-label fw">Capital/RWA Impact</label>
              <select class="form-control form-control-sm" [(ngModel)]="impactAssessment.capitalRWAImpact">
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Implementation Type</label>
              <select class="form-control form-control-sm" [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                [(ngModel)]="impactAssessment.implementationType">
                <option *ngFor="let option of implementationType" value="{{option}}">{{option}}</option>
              </select>
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Project Reference</label>
              <input type="text" class="form-control form-control-sm" [(ngModel)]="impactAssessment.projectReference"
                [matAutocomplete]="auto" (change)="setProjectPreference()">
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" class="refernce-autocomplete">
                <mat-option [value]="'Not Applicable'">
                  Not Applicable
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-3">
              <a class="btn bg-g-lightGreen btn-sm" *ngIf="!isADetailPermission">Impact Rating Detail</a>
              <button class="btn bg-g-lightGreen btn-sm" [attr.disabled]="!isImpactRating ? true: null"
                *ngIf="isADetailPermission" (click)="openImpactRating()">
                Impact Rating Detail</button>
              <div class="mt-1">
                <span class="label label-default bg-default p5-20" *ngIf="!impactAssessment.impactRating">Not
                  Performed</span>
                <span class="label label-default bg-red p5-20"
                  *ngIf="impactAssessment.impactRating === 'Very High'">Very
                  High</span>
                <span class="label ml-2 label-default bg-orange p5-20"
                  *ngIf="impactAssessment.impactRating === 'High'">High</span>
                <span class="label ml-2 label-default bg-yellow p5-20"
                  *ngIf="impactAssessment.impactRating === 'Medium'">Medium</span>
                <span class="label ml-2 label-default bg-green p5-20"
                  *ngIf="impactAssessment.impactRating === 'Low'">Low</span>
              </div>
            </div>
          </div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="isRDetailPermission && !isRDetails"
                    (click)="isRDetails = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="isRDetailPermission && isRDetails"
                    (click)="isRDetails = false"></span>
                  <span class="control-label fw">
                    Impact Details - Please provide additional details on Impact Analysis
                  </span>
                </div>
                <div class="text-area-css overflow-auto"
                  *ngIf="iaDetailHistory && iaDetailHistory.reviewDetails.length > 0">
                  <div *ngFor="let detailItem of iaDetailHistory.reviewDetails">
                    <div class="pt-3" *ngIf="detailItem.itemTitle">
                      <div class="f-16" [innerHTML]="detailItem.itemTitle"></div>
                    </div>
                  </div>
                </div>
                <div class="text-area-css overflow-auto disabled-div"
                  *ngIf="!isRDetailPermission && iaDetailHistory && iaDetailHistory.reviewDetails.length === 0"
                  [innerHTML]="sanitizeHtml(impactAssessment.reviewDetails)"></div>
                  <app-ck-editor [(childVariable)]="impactAssessment.reviewDetails" id="reviewDetails" class="f-16" *ngIf="isRDetails"></app-ck-editor>
                <!-- <ckeditor [editor]="Editor" id="reviewDetails" class="f-16" *ngIf="isRDetails"
                  [(ngModel)]="impactAssessment.reviewDetails">
                </ckeditor> -->
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <mat-accordion id="AssessmentCompliance">
        <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2 mt-2">
          <mat-expansion-panel-header class="ia-mat-panel">
            <mat-panel-title>
              <span class="text-header inc-f">
                Assessment - Compliance
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row ml-2 my-4">
            <div class="col-lg-4">
              <label class="control-label fw">Assessor</label>
              <mat-slide-toggle class="ml-2" [(ngModel)]="assessorToggle">Assign To Division</mat-slide-toggle>
              <mat-chip-list #assessorList>
                <mat-chip *ngFor="let assessor of assessorDD" [selectable]="selectable" [removable]="removable"
                  (removed)="removeAssessor(assessor)">
                  {{assessor}}
                  <mat-icon matChipRemove *ngIf="removable && isADetailPermission">x</mat-icon>
                </mat-chip>
                <input class="form-control form-control-sm mat-autodd-input border-bottom"
                  #trigautoAssessor="matAutocompleteTrigger" (keydown)="getFilteredData('Assessor', $event)"
                  [attr.disabled]="!isADetailPermission ? 'disabled' : null" #assessorInput
                  [formControl]="searchAssessorCntrl" [matAutocomplete]="assessorAutocomplete"
                  [matChipInputFor]="assessorList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur" autocomplete="off" (matChipInputTokenEnd)="addAssessor($event)">
              </mat-chip-list>
              <mat-autocomplete #assessorAutocomplete="matAutocomplete"
                (optionSelected)="selectedAssessorEvent($event)">
                <mat-option *ngFor="let assessor of (assessorToggle?searchedJurisdiction:searchedAssessor)"
                  [value]="assessorToggle?assessor.title:assessor.value">
                  {{assessorToggle?assessor.title:assessor.name}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Status</label>
              <select class="form-control form-control-sm" [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                [(ngModel)]="impactAssessment.assessmentStatus">
                <option *ngFor="let option of assessmentStatus" value="{{option}}">{{option}}</option>
              </select>
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Last Edited</label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="assessmentDueDate2"
                  [attr.disabled]="!isADetailPermission ? 'disabled' : null" (click)="assessmentDueDate.open()"
                  class="form-control form-control-sm border-bottom" [(ngModel)]="impactAssessment.assessmentDueDate"
                  name="AssessmentDueDate" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" *ngIf="isADetailPermission"
                    (click)="assessmentDueDate.open()"></span>
                  <span class="input-group-text fa fa-calendar" *ngIf="!isADetailPermission"></span>
                </div>
              </div>
              <mat-datepicker #assessmentDueDate2>
              </mat-datepicker>
            </div>
          </div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="isIDetailPermission && !isIDetails4"
                    (click)="isIDetails4 = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIDetailPermission && isIDetails4"
                    (click)="isIDetails4 = false"></span>
                  <span class="control-label fw">
                    Impact - Please provide a summary of publication's impact on
                    business/operational/processes/policies
                  </span>
                </div>
                <div class="text-area-css overflow-auto"
                  *ngIf="iaDetailHistory && iaDetailHistory.implementationDetails.length > 0">
                  <div *ngFor="let detailItem of iaDetailHistory.implementationDetails">
                    <div class="pt-3" *ngIf="detailItem.itemTitle">
                      <div class="f-16" [innerHTML]="detailItem.itemTitle"></div>
                    </div>
                  </div>
                </div>
                <div class="text-area-css overflow-auto disabled-div"
                  *ngIf="!isIDetailPermission && iaDetailHistory && iaDetailHistory.implementationDetails.length === 0"
                  [innerHTML]="sanitizeHtml(impactAssessment.implementationDetails)"></div>
                  <app-ck-editor [(childVariable)]="impactAssessment.implementationDetail" id="implementationDetails" class="f-16" *ngIf="isIDetails4"></app-ck-editor>
                <!-- <ckeditor [editor]="Editor" id="implementationDetails" class="f-16" *ngIf="isIDetails4"
                  [(ngModel)]="impactAssessment.implementationDetails">
                </ckeditor> -->
              </div>
            </div>
            <div class="col-lg-12">
              <button class="btn bg-g-lightGreen btn-sm float-right mt-2" (click)="addAssessmentDetails()">
                Add Action</button>
            </div>
          </div>
          <div class="row ml-2 mt-1" *ngFor="let item of impactAssessment.assessmentDetailsList2;let i=index">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isIADetails3"
                    (click)="isIADetails3 = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIADetails3"
                    (click)="isIADetails3 = false"></span>
                  <span class="control-label fw">
                    Action Required - Please provide a summary of the actions needed to comply with publication proposal
                  </span>
                </div>
                <div class="text-area-css overflow-auto" *ngIf="actionsRequiredArray">
                  <div>
                    <div class="pt-3" *ngIf="actionsRequiredArray">
                      <div class="f-16" [innerHTML]="actionsRequiredArray[i]"></div>
                    </div>
                  </div>
                </div>
                <div class="text-area-css overflow-auto disabled-div"
                  *ngIf="!isADetailPermission && iaDetailHistory && iaDetailHistory.actionRequired.length === 0"
                  [innerHTML]="sanitizeHtml(impactAssessment.assessmentDetailsList2)"></div>
                  <app-ck-editor [(childVariable)]="item.actionsRequired" id="actionRequired" class="f-16" *ngIf="isADetailPermission && isIADetails3" (keyUpEvent)="updateSectionLastEditedChild('Assessment')"></app-ck-editor>
                <!-- <ckeditor [editor]="Editor" id="actionRequired" class="f-16" *ngIf="isADetailPermission && isIADetails3"
                  [(ngModel)]="item.actionsRequired" (keyup)="updateSectionLastEditedChild('Assessment')">
                </ckeditor> -->
              </div>
            </div>
            <div class="col-lg-12 mt-1">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isIADetails3"
                    (click)="isIADetails3 = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIADetails3"
                    (click)="isIADetails3 = false"></span>
                  <span class="control-label fw">
                    Actions Taken - Please provide a summary of the actions taken to comply with publication proposal
                  </span>
                </div>
                <div class="text-area-css overflow-auto" *ngIf="actionsTakenArray">
                  <div>
                    <div class="pt-3" *ngIf="actionsTakenArray">
                      <div class="f-16" [innerHTML]="actionsTakenArray[i]"></div>
                    </div>
                  </div>
                </div>
                <div class="text-area-css overflow-auto disabled-div"
                  *ngIf="!isADetailPermission && iaDetailHistory && iaDetailHistory.actionRequired.length === 0"
                  [innerHTML]="sanitizeHtml(impactAssessment.assessmentDetailsList2)"></div>
                  <app-ck-editor [(childVariable)]="item.actionsTaken" id="actionsTaken" class="f-16" *ngIf="isADetailPermission && isIADetails3" (keyUpEvent)="updateSectionLastEditedChild('Assessment')"></app-ck-editor>
                <!-- <ckeditor [editor]="Editor" id="actionsTaken" class="f-16" *ngIf="isADetailPermission && isIADetails3"
                  [(ngModel)]="item.actionsTaken" (keyup)="updateSectionLastEditedChild('Assessment')">
                </ckeditor> -->
              </div>
            </div>
            <div class="col-lg-3 mt-3">
              <label class="control-label fw">Next Action Date</label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="assessmentDueDate"
                  [attr.disabled]="!isADetailPermission ? 'disabled' : null" (click)="assessmentDueDate.open()"
                  class="form-control form-control-sm border-bottom" [(ngModel)]="item.nextActionDate"
                  name="AssessmentDueDate" (dateInput)="updateSectionLastEditedChild('Assessment')" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" *ngIf="isADetailPermission"
                    (click)="assessmentDueDate.open()"></span>
                  <span class="input-group-text fa fa-calendar" *ngIf="!isADetailPermission"></span>
                </div>
              </div>
              <mat-datepicker #assessmentDueDate (selectedChanged)="updateSectionLastEditedChild('Assessment')">
              </mat-datepicker>
            </div>
            <div class="col-lg-3 mt-3">
              <label class="control-label fw">Action Status</label>
              <select class="form-control form-control-sm" [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                (change)="updateSectionLastEditedChild('AssessmentStatus')" [(ngModel)]="item.actionStatus">
                <option *ngFor="let option of assessmentStatus" value="{{option}}">{{option}}</option>
              </select>
            </div>
            <div class="col-lg-5 mt-3">
              <label class="control-label fw">Action Owner</label>
              <mat-chip-list #actionOwnerList>
                <mat-chip *ngFor="let owner of item.actionOwner|stringToArrayParent" [selectable]="selectable"
                  [removable]="removable" (removed)="removeMultipleActionOwner(owner,i)">
                  {{owner}}
                  <mat-icon matChipRemove *ngIf="removable && isADetailPermission" class="clear-icons">X</mat-icon>
                </mat-chip>
                <input class="form-control form-control-sm mat-autodd-input border-bottom"
                  #trigautoOwner="matAutocompleteTrigger" (keydown)="getFilteredData('ActionOwner', $event)"
                  [attr.disabled]="!isADetailPermission ? 'disabled' : null" #ownerInput
                  [formControl]="searchActionOwnerCntrl" [matAutocomplete]="actionOwnerAutocomplete"
                  [matChipInputFor]="actionOwnerList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
                  (matChipInputTokenEnd)="addActionOwner($event,item.actionOwner,i)">
              </mat-chip-list>
              <mat-autocomplete #actionOwnerAutocomplete="matAutocomplete"
                (optionSelected)="selectedMultipleActionOwnerEvent($event,item.actionOwner,i)">
                <mat-option *ngFor="let owner of searchedActionOwner" [value]="owner.value">
                  {{owner.name}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-1 mt-3">
              <span *ngIf="impactAssessment.assessmentDetailsList2.length>1" class="cursor-pointer fg-red"
                (click)="removeAssessmentDetails(i)"><span class="fa fa-trash"></span>
                <span class="text-primary ml-1">Delete</span>
              </span>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <!--Template 3-->
    <div *ngIf="templateNo==3">
      <mat-accordion id="AssessmentDetails">
        <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2 mt-2">
          <mat-expansion-panel-header class="ia-mat-panel">
            <mat-panel-title>
              <span class="text-header inc-f">
                Assessment Details
              </span><span *ngIf="impactAssessment.templateNo==3" class="text-danger ml-3 float-right">( * fields are
                mandatory )</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row ml-2 my-4">
            <div class="col-lg-4">
              <label class="control-label fw">Assessor <span class="stars">*</span></label>
              <mat-chip-grid #assessorList>
                <mat-chip-row *ngFor="let assessor of assessorDD" [selectable]="selectable" [removable]="removable"
                  (removed)="removeAssessor(assessor)">
                  {{assessor}}
                  <mat-icon matChipRemove *ngIf="removable && isADetailPermission">x</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm mat-autodd-input border-bottom"
                  (keydown)="getFilteredData('Assessor', $event)"
                  [attr.disabled]="!isADetailPermission ? 'disabled' : null" #assessorInput
                  [formControl]="searchAssessorCntrl" [matAutocomplete]="assessorAutocomplete"
                  [matChipInputFor]="assessorList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur" autocomplete="off" (matChipInputTokenEnd)="addAssessor($event)">
              </mat-chip-grid>
              <mat-autocomplete #assessorAutocomplete="matAutocomplete"
                (optionSelected)="selectedAssessorEvent($event)">
                <mat-option *ngFor="let assessor of searchedAssessor" [value]="assessor.value">
                  {{assessor.name}}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isIADetails1"
                    (click)="isIADetails1 = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIADetails1"
                    (click)="isIADetails1 = false"></span>
                  <span class="control-label fw">
                    Publication Proposal - Please provide a summary of what the publication is proposing <span
                      class="stars">*</span>
                  </span>
                </div>
                <div class="text-area-css overflow-auto"
                  *ngIf="iaDetailHistory && iaDetailHistory.assessmentDetails1.length > 0">
                  <div *ngFor="let detailItem of iaDetailHistory.assessmentDetails1">
                    <div class="pt-3" *ngIf="detailItem.itemTitle">
                      <div class="f-16" [innerHTML]="detailItem.itemTitle"></div>
                    </div>
                  </div>
                </div>
                <div class="text-area-css overflow-auto disabled-div"
                  *ngIf="!isADetailPermission && iaDetailHistory && iaDetailHistory.assessmentDetails1.length === 0"
                  [innerHTML]="sanitizeHtml(impactAssessment.assessmentDetails1)"></div>
                  <app-ck-editor [(childVariable)]="impactAssessment.assessmentDetails1" id="assessmentDetails1" class="f-16" *ngIf="isADetailPermission && isIADetails1"></app-ck-editor>
                <!-- <ckeditor [editor]="Editor" id="assessmentDetails1" class="f-16"
                  *ngIf="isADetailPermission && isIADetails1" [(ngModel)]="impactAssessment.assessmentDetails1">
                </ckeditor> -->
              </div>
            </div>
          </div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isIADetails2"
                    (click)="isIADetails2 = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIADetails2"
                    (click)="isIADetails2 = false"></span>
                  <span class="control-label fw">
                    Impact - Please provide a summary of publication's impact on
                    business/operational/processes/policies <span class="stars">*</span>
                  </span>
                </div>
                <div class="text-area-css overflow-auto"
                  *ngIf="iaDetailHistory && iaDetailHistory.assessmentDetails2.length > 0">
                  <div *ngFor="let detailItem of iaDetailHistory.assessmentDetails2">
                    <div class="pt-3" *ngIf="detailItem.itemTitle">
                      <div class="f-16" [innerHTML]="detailItem.itemTitle"></div>
                    </div>
                  </div>
                </div>
                <div class="text-area-css overflow-auto disabled-div"
                  *ngIf="!isADetailPermission && iaDetailHistory && iaDetailHistory.assessmentDetails2.length === 0"
                  [innerHTML]="sanitizeHtml(impactAssessment.assessmentDetails2)"></div>
                  <app-ck-editor [(childVariable)]="impactAssessment.assessmentDetails2" id="assessmentDetails2" class="f-16" *ngIf="isADetailPermission && isIADetails2"></app-ck-editor>
                <!-- <ckeditor [editor]="Editor" id="assessmentDetails2" class="f-16"
                  *ngIf="isADetailPermission && isIADetails2" [(ngModel)]="impactAssessment.assessmentDetails2">
                </ckeditor> -->
              </div>
            </div>
          </div>

          <div class="row ml-2 align-items-end mt-1">
            <div class="col-lg-3">
              <label class="control-label fw">Capital/RWA Impact</label>
              <select class="form-control form-control-sm" [(ngModel)]="impactAssessment.capitalRWAImpact">
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">
                Impact Rating Lite <span class="stars">*</span>
                <span class="label ml-2 label-default bg-default p5-20"
                  *ngIf="!impactAssessment.impactRatingLite">None</span>
                <span class="label ml-2 label-default bg-red p5-20"
                  *ngIf="impactAssessment.impactRatingLite === 'Very High'">Very
                  High</span>
                <span class="label ml-2 label-default bg-orange p5-20"
                  *ngIf="impactAssessment.impactRatingLite === 'High'">High</span>
                <span class="label ml-2 label-default bg-yellow p5-20"
                  *ngIf="impactAssessment.impactRatingLite === 'Medium'">Medium</span>
                <span class="label ml-2 label-default bg-green p5-20"
                  *ngIf="impactAssessment.impactRatingLite === 'Low'">Low</span>
              </label>
              <select class="form-control form-control-sm" [(ngModel)]="impactAssessment.impactRatingLite">
                <option value="Low">Low</option>
                <option value="Medium">Medium</option>
                <option value="High">High</option>
                <option value="Very High">Very High</option>
              </select>
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Lobbying Required ? <span class="stars">*</span></label>
              <select class="form-control form-control-sm" [(ngModel)]="impactAssessment.isLobbyingRequired">
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
            <div class="col-lg-3">
              <button class="btn bg-g-lightGreen btn-sm float-right" (click)="addAssessmentDetails()">
                Add Action</button>
            </div>
          </div>
          <div class="row ml-2 mt-1" *ngFor="let item of impactAssessment.assessmentDetailsList;let i=index">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isIADetails3"
                    (click)="isIADetails3 = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIADetails3"
                    (click)="isIADetails3 = false"></span>
                  <span class="control-label fw">
                    Actions Required - Identify necessary compliance actions for the regulatory change.
                    Use this field to record actions on details to be shared with business areas, gap analysis of
                    proposed requirements,
                    and initiating compliance-led projects <span class="stars">*</span>
                  </span>
                </div>
                <div class="text-area-css overflow-auto disabled-div"
                  *ngIf="!isADetailPermission && iaDetailHistory && iaDetailHistory.actionRequired.length === 0"
                  [innerHTML]="sanitizeHtml(impactAssessment.actionsRequired)"></div>
                  <app-ck-editor [(childVariable)]="item.actionsRequired" id="actionRequired" class="f-16" *ngIf="isADetailPermission && isIADetails3"></app-ck-editor>
                <!-- <ckeditor [editor]="Editor" id="actionRequired" class="f-16" *ngIf="isADetailPermission && isIADetails3"
                  [(ngModel)]="item.actionsRequired">
                </ckeditor> -->
              </div>
            </div>
            <div class="col-lg-3 mt-3">
              <label class="control-label fw">Next Action Date <span class="stars">*</span></label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="assessmentDueDate"
                  [attr.disabled]="!isADetailPermission ? 'disabled' : null" (click)="assessmentDueDate.open()"
                  class="form-control form-control-sm border-bottom" [(ngModel)]="item.nextActionDate"
                  name="AssessmentDueDate" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" *ngIf="isADetailPermission"
                    (click)="assessmentDueDate.open()"></span>
                  <span class="input-group-text fa fa-calendar" *ngIf="!isADetailPermission"></span>
                </div>
              </div>
              <mat-datepicker #assessmentDueDate>
              </mat-datepicker>
            </div>
            <div class="col-lg-3 mt-3">
              <label class="control-label fw">Action Status <span class="stars">*</span></label>
              <select class="form-control form-control-sm" [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                [(ngModel)]="item.actionStatus">
                <option *ngFor="let option of assessmentStatus" value="{{option}}">{{option}}</option>
              </select>
            </div>
            <div class="col-lg-5 mt-3">
              <label class="control-label fw">Action Owner <span class="stars">*</span></label>
              <mat-chip-grid #actionOwnerList>
                <mat-chip-row *ngFor="let owner of item.actionOwner|stringToArrayParent" [selectable]="selectable"
                  [removable]="removable" (removed)="removeMultipleActionOwner(owner,i)">
                  {{owner}}
                  <mat-icon matChipRemove *ngIf="removable && isADetailPermission">x</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm mat-autodd-input border-bottom"
                  #trigautoOwner="matAutocompleteTrigger" (keydown)="getFilteredData('ActionOwner', $event)"
                  [attr.disabled]="!isADetailPermission ? 'disabled' : null" #ownerInput
                  [formControl]="searchActionOwnerCntrl" [matAutocomplete]="actionOwnerAutocomplete"
                  [matChipInputFor]="actionOwnerList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
                  (matChipInputTokenEnd)="addActionOwner($event,item.actionOwner,i)">
              </mat-chip-grid>
              <mat-autocomplete #actionOwnerAutocomplete="matAutocomplete"
                (optionSelected)="selectedMultipleActionOwnerEvent($event,item.actionOwner,i)">
                <mat-option *ngFor="let owner of searchedActionOwner" [value]="owner.value">
                  {{owner.name}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-1 mt-3">
              <span *ngIf="impactAssessment.assessmentDetailsList.length>1" class="cursor-pointer fg-red"
                (click)="removeAssessmentDetails(i)"><span class="fa fa-trash"></span>
                <span class="text-primary ml-1">Delete</span>
              </span>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <mat-accordion id="ImplementationDetails">
        <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2 mt-2">
          <mat-expansion-panel-header class="ia-mat-panel">
            <mat-panel-title>
              <span class="text-header inc-f">
                Implementation Details
              </span>
              <span class="cursor-pointer ml-3" style="font-size:14px">
                <i class="fa fa-square-o icon-font vertical-align-top"
                  (click)="checkImplementationDetailRequired('Checked')" *ngIf="!isIDNotRequired"
                  aria-hidden="true"></i>
                <i class="fa fa-check-square icon-font vertical-align-top"
                  (click)="checkImplementationDetailRequired('UnChecked')" *ngIf="isIDNotRequired"
                  aria-hidden="true"></i>
                Not Required
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row ml-2 mt-1">
            <div class="col-lg-4">
              <label class="control-label fw">Implementation Team</label>
              <input type="text" [attr.disabled]="!isIDetailPermission ? 'disabled' : null"
                class="form-control form-control-sm" [(ngModel)]="impactAssessment.implementationTeam" />
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Implementation Owner</label>
              <mat-chip-grid #imptList>
                <mat-chip-row *ngFor="let implmt of imptOwnerDD" [selectable]="selectable" [removable]="removable"
                  (removed)="removeImplementationOwner(implmt)">
                  {{implmt}}
                  <mat-icon matChipRemove *ngIf="removable && isIDetailPermission">x</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm mat-autodd-input border-bottom"
                  (keydown)="getFilteredData('Owner', $event)"
                  [attr.disabled]="!isIDetailPermission ? 'disabled' : null" #imptOwnerInput
                  [formControl]="searchImptOwnerCntrl" [matAutocomplete]="imptOwnerAutocomplete"
                  [matChipInputFor]="imptList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
                  (matChipInputTokenEnd)="addImplementationOwner($event)">
              </mat-chip-grid>
              <mat-autocomplete #imptOwnerAutocomplete="matAutocomplete"
                (optionSelected)="selectedImplementationOwnerEvent($event)">
                <mat-option *ngFor="let implmt of searchedImptOwner" [value]="implmt.value">
                  {{implmt.name}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Implementation Type</label>
              <select class="form-control form-control-sm" [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                [(ngModel)]="impactAssessment.implementationType">
                <option *ngFor="let option of implementationType" value="{{option}}">{{option}}</option>
              </select>
            </div>
          </div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-4">
              <label class="control-label fw">Implementation Due Date</label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="implementationDueDate"
                  [attr.disabled]="!isIDetailPermission ? 'disabled' : null" (click)="implementationDueDate.open()"
                  class="form-control form-control-sm border-bottom"
                  [(ngModel)]="impactAssessment.implementationDueDate" name="ImplementationDueDate" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" *ngIf="isIDetailPermission"
                    (click)="implementationDueDate.open()"></span>
                  <span class="input-group-text fa fa-calendar" *ngIf="!isIDetailPermission"></span>
                </div>
              </div>
              <mat-datepicker #implementationDueDate></mat-datepicker>
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Implementation Last Edited</label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="implementationLastEdited" disabled
                  (click)="implementationLastEdited.open()" class="form-control form-control-sm border-bottom"
                  [(ngModel)]="impactAssessment.implementationLastEdited" name="ImplementationLastEdited" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" disabled
                    (click)="implementationLastEdited.open()"></span>
                </div>
              </div>
              <mat-datepicker #implementationLastEdited></mat-datepicker>
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Implementation Status</label>
              <select class="form-control form-control-sm" [attr.disabled]="!isIDetailPermission ? 'disabled' : null"
                [(ngModel)]="impactAssessment.implementationStatus">
                <option *ngFor="let option of implementationStatus" value="{{option}}">{{option}}</option>
              </select>
            </div>
          </div>

          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text mb-3">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="isIDetailPermission && !isIDetails"
                    (click)="isIDetails = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIDetailPermission && isIDetails"
                    (click)="isIDetails = false"></span>
                  <span class="control-label fw">
                    Implementation Details
                  </span>
                </div>
                <div class="text-area-css overflow-auto disabled-div" *ngIf="!isIDetailPermission"
                  [innerHTML]="sanitizeHtml(impactAssessment.implementationDetails)"></div>
                  <app-ck-editor [(childVariable)]="impactAssessment.implementationDetails" id="implementationDetails" class="f-16" *ngIf="isIDetails"></app-ck-editor>
                <!-- <ckeditor [editor]="Editor" id="implementationDetails" class="f-16" *ngIf="isIDetails"
                  [(ngModel)]="impactAssessment.implementationDetails">
                </ckeditor> -->
              </div>
            </div>
          </div>
          <div class="row ml-2 pt-3">
            <div class="col-lg-4">
              <label class="control-label fw">Project Reference</label>
              <input type="text" class="form-control form-control-sm" [(ngModel)]="impactAssessment.projectReference"
                [matAutocomplete]="auto" (change)="setProjectPreference()">
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" class="refernce-autocomplete">
                <mat-option [value]="'Not Applicable'">
                  Not Applicable
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>
<!-- <div class="modal-footer">

</div> -->
<!-- </div> -->